
<template>
    <button data-target="modalcontact" class="waves-effect waves-light btn cta-btn modal-trigger">Contactez-Moi !</button>
</template>

<script>
export default {
  name: 'ctabutton'
}
</script>

<style scoped>
.cta-btn {
    background-color: #e84855;
    box-shadow: 0 0 0 0 rgba(232, 72, 85, 0.5);
    animation: pulse 10s infinite;
}
.cta-btn:hover {
    animation: none;
}
@keyframes pulse {
  10% {box-shadow: 0 0 0 25px rgba(232, 72, 85, 0);}
  90% {box-shadow: 0 0 0 0 rgba(232, 72, 85, 0);}
}
</style>



// WEBPACK FOOTER //
// src/components/Ctabutton.vue